import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {Menu as RmwcMenu} from '@rmwc/menu'
import '@rmwc/menu/styles'

export const StyledRmwcMenu = styled(RmwcMenu)`
  &&& .mdc-list {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: 14px;
  }
`

const Menu = ({children, ...otherProps}) => <StyledRmwcMenu {...otherProps}>{children}</StyledRmwcMenu>

Menu.propTypes = {
  children: PropTypes.any,
  focusOnOpen: PropTypes.bool,
  onSelect: PropTypes.func
}

Menu.defaultProps = {
  focusOnOpen: false
}

export {Menu}
